module.exports = __webpack_public_path__ + "static/media/kushner-witkoff.d8809cba.png";